// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"az_Nwc","legal":"az_Owc"};